// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit"

// ** ThemeConfig Import
import themeConfig from "@configs/themeConfig"

const initialMenuCollapsed = () => {
  const item = window.localStorage.getItem("menuCollapsed")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.menu.isCollapsed
}

const initialDirection = () => {
  const item = window.localStorage.getItem("direction")
  const lang = window.localStorage.getItem("i18nextLng")

  if (lang !== undefined && lang !== null && lang !== "") {
    return lang === "ar" || lang === "kr"
  }
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.isRTL
}

const initialLanguage = () => {
  const item = window.localStorage.getItem("i18nextLng")
  //** Parse stored json or if none return initialValue
  return item ? item : themeConfig.layout.lang
}

const initialSkin = () => {
  const item = window.localStorage.getItem("skin")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.skin
}

const initialLayout = () => {
  const item = window.localStorage.getItem("layout")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.type
}

const initialFooterType = () => {
  const item = window.localStorage.getItem("footerType")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.footer.type
}

const initialNavbarType = () => {
  const item = window.localStorage.getItem("navbarType")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.navbar.type
}

const initialNenuHidden = () => {
  const item = window.localStorage.getItem("menuHidden")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.menu.isHidden
}

const initialContentWidth = () => {
  const item = window.localStorage.getItem("contentWidth")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.contentWidth
}

const initialNavbarColor = () => {
  const item = window.localStorage.getItem("navbarColor")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.navbar.backgroundColor
}

export const layoutSlice = createSlice({
  name: "layout",
  initialState: {
    lang: initialLanguage(),
    skin: initialSkin(),
    isRTL: initialDirection(),
    layout: initialLayout(),
    lastLayout: initialLayout(),
    menuCollapsed: initialMenuCollapsed(),
    footerType: initialFooterType(),
    navbarType: initialNavbarType(),
    menuHidden: initialNenuHidden(),
    contentWidth: initialContentWidth(),
    navbarColor: initialNavbarColor()
  },
  reducers: {
    handleRTL: (state, action) => {
      state.isRTL = action.payload
      window.localStorage.setItem("direction", JSON.stringify(action.payload))
    },
    handleSkin: (state, action) => {
      state.skin = action.payload
      window.localStorage.setItem("skin", JSON.stringify(action.payload))
    },
    handleLayout: (state, action) => {
      state.layout = action.payload
      window.localStorage.setItem("layout", JSON.stringify(action.payload))
    },
    handleFooterType: (state, action) => {
      state.footerType = action.payload
      window.localStorage.setItem("footerType", JSON.stringify(action.payload))
    },
    handleNavbarType: (state, action) => {
      state.navbarType = action.payload
      window.localStorage.setItem("navbarType", JSON.stringify(action.payload))
    },
    handleMenuHidden: (state, action) => {
      state.menuHidden = action.payload
      window.localStorage.setItem("menuHidden", JSON.stringify(action.payload))
    },
    handleLastLayout: (state, action) => {
      state.lastLayout = action.payload
      window.localStorage.setItem("layout", JSON.stringify(action.payload))
    },
    handleNavbarColor: (state, action) => {
      state.navbarColor = action.payload
      window.localStorage.setItem("navbarColor", JSON.stringify(action.payload))
    },
    handleContentWidth: (state, action) => {
      state.contentWidth = action.payload
      window.localStorage.setItem("contentWidth", JSON.stringify(action.payload))
    },
    handleMenuCollapsed: (state, action) => {
      state.menuCollapsed = action.payload
      window.localStorage.setItem(
        "menuCollapsed",
        JSON.stringify(action.payload)
      )
    }
  }
})

export const {
  handleRTL,
  handleSkin,
  handleLayout,
  handleLastLayout,
  handleMenuHidden,
  handleNavbarType,
  handleFooterType,
  handleNavbarColor,
  handleContentWidth,
  handleMenuCollapsed
} = layoutSlice.actions

export default layoutSlice.reducer
